import React from 'react'

interface LoadingBarStripesProps {
    percentLoaded: number
}

const LoadingBarStripes: React.FC<LoadingBarStripesProps> = ({ percentLoaded }) => {
    return (
        <div
            className="stripesLoader"
            style={{ backgroundPosition: `${percentLoaded}%` }}
        />
    )
}

export { LoadingBarStripes }
